import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import CheckboxMUI from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";

const FormLabelStyled = styled(FormLabel)(({ theme }) => ({
  fontSize: "0.8em",
  color: theme.palette.text.primary,
}));

function Checkbox({ methods, label, name, required, defaultChecked }) {
  const {
    control,
    formState: { errors },
    setValue,
  } = methods;

  const handleChange = (event) => {
    setValue(name, event.target.checked);
    return event.target.checked;
  };

  return (
    <React.Fragment>
      <FormControl
        required={required}
        error={errors?.hasOwnProperty(name)}
        component="fieldset"
        fullWidth
      >
        <FormGroup>
          <Controller
            name={name}
            rules={{ required }}
            control={control}
            render={({ field }) => {
              return (
                <FormControlLabel
                  {...field}
                  onChange={(event) => field.onChange(handleChange(event))}
                  control={<CheckboxMUI defaultChecked={defaultChecked} color="primary" />}
                  label={
                    <FormLabelStyled component="legend">
                      {label}
                    </FormLabelStyled>
                  }
                />
              );
            }}
          />
        </FormGroup>
      </FormControl>
    </React.Fragment>
  );
}

Checkbox.defaultProps = {
  label: "Opt-in",
  name: "optin",
  required: true,
  defaultChecked: false,
};

Checkbox.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * Texte/react fragment à afficher après la case à cocher
   */
  label: PropTypes.node,
  /**
   * Name du tag HTML input
   */
  name: PropTypes.string,
  /**
   * La checkbox doit-elle être cochée pour valider le formulaire ?
   */
  required: PropTypes.bool,
  /**
   * La checkbox doit-elle être cochée par défaut ?
   */
  defaultChecked: PropTypes.bool,
};

export default Checkbox;
